import { useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {EMPTY_VALUES, getDateFormat} from "../../../../Apis/functions";
import {SearchCrudLogByModel} from "../../../../reduxToolkit/Search/SearchApi";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import TableFunction from "../../../../components/table/TableFunction";
import {resetSearchCrudLogByModel} from "../../../../reduxToolkit/Search/SearchSlice";
import {CRITERIA_MODEL, DEFAULT_LEFT} from "../../../../components/table/Model/TableModel";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ActionLogsTableApp = ({  modified,setModified,modelType, finalArray}) =>
{
    const dispatch = useDispatch();
    const tableId = "tbl_lt_supplier_docs";
    const searchId = "txt_lt_search_supplier_docs";
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const [bodyForExports, setBodyForExports] = useState('');
    const leftPosition = DEFAULT_LEFT;

    //Returns an array of table header elements
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('user')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('action')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('platform')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('date')}</CustomTh>
        ];
    }
    //Returns an object with the body components and raw data
    const getTbody = () => {
        if(!results || results?.totalElements === 0 || results?.length === 0 ) return {
            body: [],
            data: []
        };

        let body =  results?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        {item?.userFullName}
                    </CustomTd>
                    <CustomTd tableId={tableId} >{t(item?.action?.toLowerCase()).toLocaleUpperCase()}</CustomTd>
                    <CustomTd tableId={tableId} >{t(item?.platform?.toLowerCase()).toLocaleUpperCase()}</CustomTd>
                    <CustomTd tableId={tableId} >{getDateFormat(item?.createdAt) || EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = () => {
        return <></>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        if(modelType){
             const criteriaList = finalArray.map((item) => {
                return CRITERIA_MODEL.set(item);
            });

            const body = {
                pagination: {
                    page: page,
                    size: rowsPerPage,
                },
                 searchCriteriaList: criteriaList
            };

            dispatch(SearchCrudLogByModel({ model: modelType, body: body })).then(
                ({payload: {data: { data, success }}}) => {
                    if (success === true) {
                        setResults(data);
                    }
                },
            );
        }else{
            dispatch(resetSearchCrudLogByModel());
        }
    }

    // Setup table functions and pagination using shared TableFunction logic
    const {t, thead, tbody, handleCheckboxChange,
        pagination, page, setPage, rowsPerPage, setRowsPerPage} = TableFunction({
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage:'actions_per_page',
        hasContainer:true,
        fixedPagination:false,
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        pagination, page, setPage, rowsPerPage, setRowsPerPage,
        DEV,
        permission,
        setBodyForExports
    };

}
export default ActionLogsTableApp;
